import { toast } from 'react-toastify';
import appApi from '../../../../../../../api/app-api';
import { displayErrorText } from '../../../../../../../api/errors/api-error-codes';

export const addUsersToPermissionGroupOperation = async (
  groupId: number,
  userIds: number[],
  setLoading: (loading: boolean) => void,
  onSuccess: () => void,
) => {
  const uniqueUserIds = [...new Set(userIds)];

  if (uniqueUserIds.length === 0) {
    toast.warn('יש לבחור לפחות משתמש אחד');
    return;
  }

  try {
    setLoading(true);

    const res = await appApi.addUsersToPermissionGroup(groupId, uniqueUserIds);

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      return;
    }

    toast.success('המשתמשים נוספו לקבוצה בהצלחה');
    onSuccess();
  } catch (e) {
    console.error('addUsersToPermissionGroupOperation failed:', e);
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
  } finally {
    setLoading(false);
  }
};
